/**
 * Maps a URL hash (e.g. `#jackets`) to the filter value whose anchor ID matches.
 * Returns undefined for an empty hash or an unknown anchor so callers keep the default filter.
 */
export function resolveFilterFromHash(
  hash: string,
  filters: { value: string; anchorId?: string }[] | undefined
): string | undefined {
  if (!hash || !filters?.length) return undefined;

  let anchorId = hash.slice(1);
  try {
    anchorId = decodeURIComponent(anchorId);
  } catch {
    // Keep the raw value; a malformed hash simply won't match any anchor.
  }
  if (!anchorId) return undefined;

  return filters.find((filter) => filter.anchorId === anchorId)?.value;
}
